import React from 'react'
import {ButtonLabel} from '../../Typography';
import classnames from 'classnames';

export class SubmitButton extends React.Component{
  constructor (props) {
    super(props);
    this.state = {
      hover: false
    };
  }
  render(){
    const className= classnames(
      'p-button text-center align-bottom px-3 py-1 rounded',
      {
        'bg-aubergine': !this.props.disabled,
        'bg-gray-200': this.props.disabled
      },
      this.props.className
    );
    return (
      <button
        className={className}
        onClick={this.props.onClickHandler}
        onMouseEnter={e=>{this.setState({hover:true});}}
        onMouseLeave={e=>{this.setState({hover:false});}}
        type='submit'
        value="Submit"
        disabled={this.props.disabled?this.props.disabled:false}
      >
        <ButtonLabel hover={this.state.hover} dangerouslySetInnerHTML={{__html:this.props.label}} />
      </button>
    );
  }
}

